<template v-bind="$props">
  <div>
    <v-dialog
      persistent
      :value="enrollModeratorDialog"
      @input="$emit('close-dialog')"
      max-width="65rem"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Moderator Enrollment</v-toolbar-title>
        </v-toolbar>
        <v-container fluid style="max-height: 22rem; overflow-y: auto">
          <v-data-table
            v-if="moderators.length > 0"
            v-model="selectedModerator"
            :headers="moderatorAssignmentHeaders"
            :items="moderators"
            :hide-default-footer="moderators.length <= 10"
            show-select
            item-key="userId"
            item-value="userId"
            :single-select="true"
            @contextmenu:row="rightClickHandler"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-row justify="center">
                <v-col>
                  <v-chip
                    small
                    :color="
                      item.status == 'ACTIVE' ? 'success-chip' : 'error-chip'
                    "
                  >
                    {{ item.status }}
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.createdOn`]="{ item }">
              {{ formatDateTime(item.createdOn) }}
            </template>
            <template
              v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
            >
              <v-simple-checkbox
                :disabled="item.status != 'ACTIVE'"
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
          </v-data-table>
          <CustomDataTable
            v-else
            :headers="moderatorAssignmentHeaders"
            :items="moderators"
            :hide-default-footer="moderators.length <= 10"
          />
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeEnrollDialog()">Cancel</v-btn>
          <v-btn color="primary" text @click="enrollModerator()">Assign</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { formatDateTime, rightClickHandler } from "@/common/utility";
import { fetchUsers } from "@/services/ClassRoomService";
import { SET_OVERLAY_VALUE } from "@/store/mutations";
import { GET_TOKEN } from "@/store/getters";
import { mapMutations, mapGetters } from "vuex";
import CustomDataTable from "@/components/CustomDataTable.vue";
import { moderatorAssignmentHeaders } from "@/common/tableHeadersData";
export default {
  props: {
    enrollModeratorDialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedModerator: [],
      moderators: [],
      moderatorAssignmentHeaders: moderatorAssignmentHeaders,
    };
  },
  components: {
    CustomDataTable,
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
    }),
  },
  mounted: function () {
    this.loadModerators();
  },
  methods: {
    ...mapMutations({
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
    }),
    closeEnrollDialog() {
      this.$emit("close-dialog");
    },
    enrollModerator() {
      if (this.selectedModerator.length == 0) {
        this.$toast.error("Please select a moderator to assign");
        return;
      }
      this.$emit("assign-moderator", this.selectedModerator[0]);
      this.closeEnrollDialog();
    },
    formatDateTime(date) {
      return formatDateTime(date);
    },
    rightClickHandler(e, item) {
      e.preventDefault();
      let textInCell = e.target.textContent;
      if (!textInCell) return;
      if (textInCell.slice(-3) === "...") {
        let curText = textInCell.slice(0, -3);
        let itemData = Object.entries(item.item);
        let findSameText = itemData.find((el) => {
          return el[1]?.toString().includes(curText);
        });
        if (findSameText) {
          this.contextMenuObject = rightClickHandler(
            findSameText[1],
            e.clientX,
            e.clientY
          );
          return;
        }
      }
      this.contextMenuObject = rightClickHandler(
        textInCell,
        e.clientX,
        e.clientY
      );
    },
    loadModerators() {
      this.setOverlayValue(true);
      let payload = { userType: "MODERATOR" };
      fetchUsers(payload)
        .then((res) => {
          this.moderators = res.data.users;
          this.setOverlayValue(false);
        })
        .catch((error) => {
          this.$toast.error(error.errorMessage);
          this.setOverlayValue(false);
        });
    },
  },
};
</script>